import { ServiceModel } from "./service-model";

export class RequestModel {
  constructor() {
    this.Closed = false;
    this.IsDraft = false;
    this.SubmitOnBehaveOfSomeone = false;
    this.Service = new ServiceModel();
  }
  Id: string;
  ReferenceNumber: string;
  RequestorEmail: string;
  RequestorName: string;
  RequestorMobileNumber: string;
  RequestorEmiratesId: string;
  RequestorDOB: string;
  CreatedOn: string;
  EndDate: string;
  LastActionDate: string;
  CRMRequestID: string
  CRMReferenceNumber: string
  Closed: boolean;
  HappinessSubmit: boolean;
  IsDraft: boolean;
  MissionOfficer: string;
  ServiceId: number;
  Service: ServiceModel;
  CityId: string;
  MissionId: string;
  CountryId: string;
  SubmitOnBehaveOfSomeone: boolean;
  OnBehaveEmiratesId: string;
  OnBehaveFirstName: string;
  OnBehaveLastName: string;
  OnBehaveDOB: string;
  OnBehaveEmail: string;
  OnBehaveMobileNumber: string;
  OnBehaveRelationType: string;
  HappinessCentreId: string;
  ConcernedDepartmentId: string;
  IsMobile: boolean;
  MobileOS: string;
  UnifiedNumber: string;
  IsResponsive?: boolean;
  IsiOS?: boolean;
}
